module.exports = __webpack_public_path__ + "3df187bc492ef9b5c2a3b36ac3b47fa0.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/iphone6-white-large.png
// module id = 844
// module chunks = 0